if (!customElements.get('l-header-sticky-nav')) {
	customElements.define(
		'l-header-sticky-nav',
		class HeaderStickyNav extends HTMLElement {
			connectedCallback() {
				this.headerEl = this.closest('.l-header')
				if (!this.headerEl) return

				this.railEl = this.querySelector('[data-sticky-nav-rail]')
				this.scrimEl = this.querySelector('[data-sticky-nav-scrim]')
				this.tabEls = Array.from(this.querySelectorAll('[data-sticky-nav-tab]'))
				this.panelEls = Array.from(this.querySelectorAll('[data-sticky-nav-panel]'))
				this.coveredEls = Array.from(
					this.headerEl.querySelectorAll('.l-header__group--left, .l-header__logo, .l-header__group--right')
				)

				this.threshold = 120
				this.closeDelta = 64
				this.openKey = null
				this.openScrollY = 0
				this.onScroll = this.onScroll.bind(this)
				this.onKeydown = this.onKeydown.bind(this)
				this.onProductAdded = this.onProductAdded.bind(this)

				this.tabEls.forEach((tabEl) => {
					tabEl.addEventListener('click', () => this.togglePanel(tabEl))
				})
				this.scrimEl?.addEventListener('click', () => this.closePanel())
				window.addEventListener('scroll', this.onScroll, { passive: true })
				document.addEventListener('keydown', this.onKeydown)

				if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
					this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event))
				}
				document.addEventListener('l:product:added', this.onProductAdded)

				if (typeof ResizeObserver !== 'undefined' && this.railEl) {
					this.railObserver = new ResizeObserver(() => this.syncRailOverflow())
					this.railObserver.observe(this.railEl)
				}

				this.setCartEmpty(this.dataset.cartEmpty === 'true')
				this.onScroll()
				this.syncRailOverflow()
			}

			disconnectedCallback() {
				window.removeEventListener('scroll', this.onScroll)
				document.removeEventListener('keydown', this.onKeydown)
				document.removeEventListener('l:product:added', this.onProductAdded)
				this.railObserver?.disconnect()
				this.cartUnsubscriber?.()
			}

			onProductAdded() {
				this.setCartEmpty(false)
			}

			onCartUpdate(event) {
				const itemCount = event?.cartData?.item_count
				if (typeof itemCount === 'number') {
					this.setCartEmpty(itemCount === 0)
					return
				}
				this.setCartEmpty(false)
			}

			setCartEmpty(isEmpty) {
				this.headerEl.classList.toggle('is-cart-empty', isEmpty)
				if (!isEmpty) this.closePanel()
				this.syncCoveredEls()
			}

			onScroll() {
				const scrollY = window.scrollY
				const isScrolled = scrollY > this.threshold
				this.headerEl.classList.toggle('is-nav-scrolled', isScrolled)
				if (!isScrolled || Math.abs(scrollY - this.openScrollY) > this.closeDelta) this.closePanel()
				this.syncCoveredEls()
			}

			onKeydown(event) {
				if (event.key !== 'Escape' || !this.openKey) return
				this.closePanel()
			}

			get isActive() {
				return (
					!!this.headerEl &&
					this.offsetParent !== null &&
					this.headerEl.classList.contains('is-nav-scrolled') &&
					this.headerEl.classList.contains('is-cart-empty')
				)
			}

			syncRailOverflow() {
				if (!this.railEl) return
				const isOverflowing = this.railEl.scrollWidth > this.railEl.clientWidth + 1
				if (isOverflowing === this.wasOverflowing) return
				this.wasOverflowing = isOverflowing
				this.classList.toggle('is-rail-overflowing', isOverflowing)
			}

			syncCoveredEls() {
				const rails = Array.from(document.querySelectorAll('l-header-sticky-nav'))
				const isActive = rails.some((el) => el.isActive === true)
				if (isActive === this.wasActive) return
				this.wasActive = isActive
				this.coveredEls.forEach((el) => {
					el.inert = isActive
				})
			}

			togglePanel(tabEl) {
				const key = tabEl.dataset.stickyNavTab
				if (this.openKey === key) {
					this.closePanel()
					return
				}
				this.openPanel(key, tabEl)
			}

			openPanel(key, tabEl) {
				this.openKey = key
				this.openScrollY = window.scrollY
				this.tabEls.forEach((el) => el.setAttribute('aria-expanded', String(el === tabEl)))
				this.panelEls.forEach((el) => {
					el.hidden = el.dataset.stickyNavPanel !== key
				})
				this.classList.add('is-panel-open')
				this.revealTab(tabEl)
			}

			closePanel() {
				if (!this.openKey) return
				this.openKey = null
				this.tabEls.forEach((el) => el.setAttribute('aria-expanded', 'false'))
				this.panelEls.forEach((el) => {
					el.hidden = true
				})
				this.classList.remove('is-panel-open')
			}

			revealTab(tabEl) {
				if (!this.railEl) return
				const tabRect = tabEl.getBoundingClientRect()
				const railRect = this.railEl.getBoundingClientRect()
				const gap = 8
				if (tabRect.left < railRect.left + gap) {
					this.railEl.scrollBy({ left: tabRect.left - railRect.left - gap, behavior: 'smooth' })
					return
				}
				if (tabRect.right > railRect.right - gap) {
					this.railEl.scrollBy({ left: tabRect.right - railRect.right + gap, behavior: 'smooth' })
				}
			}
		}
	)
}
